<script>
export default {
    name: "NoRecord", 
    template: "#templateNoRecord"
}
</script>
